class t {
  clone() {
    return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
  }
}
export {
  t as Model
};
//# sourceMappingURL=model.js.map
